module.exports = __webpack_public_path__ + "img/cs.3821d07d.jpeg";